import React, { useEffect, useState } from "react";
import { startLoader, stopLoader } from "../../../lib/utils";
import Toast from "../../../lib/toast";
import { cancelMemberships } from "../../memberships/helper/api";
import { isAuthenticated } from "../../../auth";

const DeleteMembershipModal = (props) => {

  const membership = props.membership;
  const packageMemberships = props.packageMemberships || [];
  const [isButtonLock,setButtonLock] = useState(false);
  const {user,token} = isAuthenticated();

  useEffect(() => {
    console.log(props)
  },[props])

  const CancelMemberships = async event =>{
    try{

      await startLoader()
      setButtonLock(true)

      const membershipIDs = packageMemberships && packageMemberships.length > 0
      ? packageMemberships.map(m => m._id)
      : [membership._id];

      const payload = {
        membershipIDs
      }

      console.log(payload)

      const response = await cancelMemberships(user._id,token,payload);


      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Membership cancelled successfully"
        })
        props.reload();
        props.toggleFitnessTestModal("delete-membership")
      }

    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:error
      })
    }

    setButtonLock(false)
    await stopLoader()
  }

  // if(!membership || !packageMemberships) return <></>;

  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "delete-membership-modal flex-item" : "w-full h-full"}`} style={window.innerWidth > 767 ? {} : {display:"flex", flexDirection:"column", height:"100%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.92401 23C3.25701 23 2.68651 22.7691 2.21251 22.3072C1.73851 21.8454 1.50101 21.2916 1.50001 20.646V2.58148H0.75001C0.53701 2.58148 0.35901 2.51148 0.21601 2.37146C0.0730103 2.23145 0.00101027 2.05789 1.02739e-05 1.85079C-0.000989725 1.64369 0.0710103 1.47062 0.21601 1.33158C0.36101 1.19254 0.53901 1.12302 0.75001 1.12302H6C6 0.821602 6.115 0.559078 6.345 0.335447C6.575 0.111816 6.845 0 7.155 0H13.845C14.155 0 14.425 0.111816 14.655 0.335447C14.885 0.559078 15 0.821602 15 1.12302H20.25C20.463 1.12302 20.641 1.19302 20.784 1.33304C20.927 1.47305 20.999 1.64661 21 1.85371C21.001 2.06081 20.929 2.23388 20.784 2.37292C20.639 2.51196 20.461 2.58148 20.25 2.58148H19.5V20.6446C19.5 21.2921 19.2625 21.8464 18.7875 22.3072C18.3125 22.7681 17.7425 22.999 17.0775 23H3.92401ZM18 2.58148H3.00001V20.6446C3.00001 20.9061 3.08651 21.121 3.25951 21.2892C3.43251 21.4574 3.65401 21.5415 3.92401 21.5415H17.0775C17.3465 21.5415 17.5675 21.4574 17.7405 21.2892C17.9135 21.121 18 20.9061 18 20.6446V2.58148ZM7.962 18.6246C8.175 18.6246 8.3535 18.5546 8.4975 18.4146C8.6415 18.2746 8.713 18.1015 8.712 17.8954V6.22765C8.712 6.02054 8.64 5.84747 8.496 5.70843C8.352 5.56939 8.1735 5.49939 7.9605 5.49841C7.7475 5.49744 7.5695 5.56745 7.4265 5.70843C7.2835 5.84942 7.212 6.02249 7.212 6.22765V17.8954C7.212 18.1025 7.284 18.2755 7.428 18.4146C7.572 18.5546 7.75 18.6246 7.962 18.6246ZM13.0395 18.6246C13.2525 18.6246 13.4305 18.5546 13.5735 18.4146C13.7165 18.2746 13.788 18.1015 13.788 17.8954V6.22765C13.788 6.02054 13.716 5.84747 13.572 5.70843C13.428 5.56842 13.25 5.49841 13.038 5.49841C12.825 5.49841 12.6465 5.56842 12.5025 5.70843C12.3585 5.84845 12.287 6.02152 12.288 6.22765V17.8954C12.288 18.1025 12.36 18.2755 12.504 18.4146C12.648 18.5536 12.8265 18.6236 13.0395 18.6246Z" fill="white"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white m-l-4">Cancel Membership</p>
              </div>
              <div onClick={()=>props.toggleFitnessTestModal("delete-membership")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        {
          packageMemberships.length > 0 ? (
            packageMemberships.map((membership, index) => {
              return(
                <div className="w-full" style={{flex: window.innerWidth > 767 ? "none" : 1, height: window.innerWidth > 767 ? "92%" : "auto", overflowY:"auto", padding:"12px", borderBottom:"1px dashed #9a9a9a"}}>
                  <div className="d-flex w-full m-b-12">
                    <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Name</p>
                    <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipplans[0].name}</p>
                  </div>
                  <div className="d-flex w-full m-b-12">
                    <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Duration</p>
                    <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipplans[0].packages[0].duration} {membership.membershipplans[0].packages[0].durationType}'s</p>
                  </div>
                  <div className="d-flex w-full m-b-12">
                    <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Session</p>
                    <p className="flex-item font-weight-700 color-dark-blue">{membership.completed_sessions?membership.completed_sessions:0} / {membership.sessions + Number(membership?.add_on_days || 0)}</p>
                  </div>
                  <div className="d-flex w-full m-b-12">
                    <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Start Date</p>
                    <p className="flex-item font-weight-700 color-dark-blue">{membership.starts_at_string}</p>
                  </div>
                  <div className="d-flex w-full m-b-12">
                    <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>End Date</p>
                    <p className="flex-item font-weight-700 color-dark-blue">{membership.ends_at_string}</p>
                  </div>
                </div>
              )
            })
          ) : (
            <div className="w-full" style={{flex: window.innerWidth > 767 ? "none" : 1, height: window.innerWidth > 767 ? "92%" : "auto", overflowY:"auto", padding:"12px"}}>
              <div className="d-flex w-full m-b-12">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Name</p>
                <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipplans[0].name}</p>
              </div>
              <div className="d-flex w-full m-b-12">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Duration</p>
                <p className="flex-item font-weight-700 color-dark-blue">{membership.membershipplans[0].packages[0].duration} {membership.membershipplans[0].packages[0].durationType}'s</p>
              </div>
              <div className="d-flex w-full m-b-12">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Session</p>
                <p className="flex-item font-weight-700 color-dark-blue">{membership.completed_sessions?membership.completed_sessions:0} / {membership.sessions + Number(membership?.add_on_days || 0)}</p>
              </div>
              <div className="d-flex w-full m-b-12">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Start Date</p>
                <p className="flex-item font-weight-700 color-dark-blue">{membership.starts_at_string}</p>
              </div>
              <div className="d-flex w-full m-b-12">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>End Date</p>
                <p className="flex-item font-weight-700 color-dark-blue">{membership.ends_at_string}</p>
              </div>
              <div className="d-flex w-full">
                <p className="flex-item" style={{width: window.innerWidth > 767 ? "160px" : "140px", flexShrink:0, color:"#6D6D6D"}}>Invoice Number</p>
                <p className="flex-item font-weight-700 color-blue">{membership?.payments?.[0]?.invoice_number}</p>
              </div>
            </div>
          )
        }
         <div  className='d-flex space-between'  style={ window.innerWidth > 767 ? {background:"#ffffff", padding:"12px", borderRadius:"0 0 20px 20px", marginTop:"20px"} : {background:"#ffffff", padding:"12px", marginTop:"auto", flexShrink:0, width:"100%", boxSizing:"border-box"} } >
          <div onClick={()=>props.toggleFitnessTestModal("delete-membership")} className={`member-button-global btn-center d-flex member-button-global-inactive`} style={{ width: window.innerWidth > 767 ? "48%" : "49%", height: window.innerWidth > 767 ? "40px" : "44px", borderRadius:"20px" }}>
            <p className="flex-item">Cancel</p>
          </div>
          <div onClick={isButtonLock?null:CancelMemberships} className={`member-button-global btn-center d-flex`} style={{ width: window.innerWidth > 767 ? "48%" : "49%", height: window.innerWidth > 767 ? "40px" : "44px", borderRadius:"20px", background:isButtonLock?"#e0e0e0":"#E33A34",pointerEvents:isButtonLock?'none':'auto'}}>
            <p className="flex-item" style={{color:isButtonLock?"#000":"#ffffff"}}>Continue</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteMembershipModal;